import Layout from "components/layout";
import React from "react";
import Reviews from "components/homepage/reviews";
import Checkus from "components/reviewPageComps/checkus";
import AllReviews from "components/reviewPageComps/allReviews";
import LeaveReview from "components/reviewPageComps/leaveReview";
import TranslateAgency from "components/homepage/translateAgency";
import GetStarted from "components/reviewPageComps/getStarted";
import TranslationServices from "components/homepage/translationServices";
import GetInTouch from "../components/getInTouch";
import Featured from "components/homepage/featured";
import SEO from "components/seo";

export default function index() {
  const title = "Reviews | Tomedes";
  const description =
    "Learn about Tomedes translation service through our customers' experiences";
  const keywords = "tomedes reviews";

  return (
    <Layout>
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        slug="/reviews.php"
      />
      <Reviews
        backgroundCol="bg-darkBlue"
        head=" "
        content
        headB
        socialIcons=" "
      />
      <Checkus />
      <AllReviews />
      <LeaveReview />
      <TranslateAgency
        head="Trusted by Business Customers"
        colorHead="Worldwide"
        BackgroundCol="bg-midBlue"
      />
      <GetStarted />
      <Featured />
      <GetInTouch backgroundCol="bg-darkBlue" />
    </Layout>
  );
}
